import { Tooltip } from '@mui/material';
import clsx from 'clsx';

interface Props {
  onClick?: () => void;
  icon: any;
  id: string;
  buttonStyles?: string;
  iconStyles?: string;
  tooltipText?: string;
  changeColorOnHover?: boolean;
  disableHoverStyles?: boolean;
  disabled?: boolean;
}

export const ActionButton: React.FC<Props> = ({
  onClick,
  icon,
  id,
  buttonStyles,
  tooltipText,
  changeColorOnHover,
  disabled,
  iconStyles,
  disableHoverStyles = false,
}) => {
  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    onClick?.();
  };

  return (
    <Tooltip title={tooltipText}>
      <button onClick={handleButtonClick} id={id} aria-label={id} className={buttonStyles} disabled={disabled}>
        <img
          className={clsx(
            'w-9 h-9 min-w-9 icon',
            iconStyles,
            changeColorOnHover && 'lightIcon',
            !disableHoverStyles && 'hover:bg-[var(--other-hover)]'
          )}
          src={icon}
          alt={id}
          id={`img-${id}`}
        />
      </button>
    </Tooltip>
  );
};
